import * as React from "react";
import classnames from "classnames";

import { iTableColumn, iTableRow } from "./interfaces";
import { Head, Rows } from "./";

export interface iProps {
  /**
   * Class name to add to the table.
   *
   * @var string
   */
  className?: string;

  /**
   * The table columns.
   *
   * @var {iTableColumn[]}
   */
  columns: iTableColumn[];

  /**
   * The table row data.
   *
   * @var {iTableRow[]}
   */
  rows: iTableRow[];
}

/**
 * Render a table.
 */
const Table: React.SFC<iProps> = (props: iProps) => (
  <div className="table-responsive">
    <table className={classnames("table", props.className)}>
      <Head columns={props.columns} />
      <Rows columns={props.columns} rows={props.rows} />
    </table>
  </div>
);

export default Table;
